import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "./navbar.css";
// import backg from "../../assets/audio/images/sec-bg.jpg";
// import masjid1 from "../../assets/audio/images/masjid1715.jpg";
import dashboard from "../../assets/audio/images/dashboard1715.jpg";

import imageSadqa from "../../assets/audio/images/homebanner.jpg";
// import { Link } from 'react-router-dom';
import NavbarAll from './NavbarAll';
import JamaatTimings from '../PrayerTimeComponent/JamatTime';
import ReactTicker from '../ReactTicker/ReactTicker';

const Navbar3 = () => {
 
  const settings = {
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    speed: 1000,
    draggable: true,
    dots: false,
    pauseOnDotsHover: true,
    pauseOnFocus: false,
    pauseOnHover: false,
  };
    
  return (
    <>
      <NavbarAll />
      {/* <JamaatTimings /> */}
      <section>
  <div className="w-100 position-relative">
    <div className="feat-wrap v2 position-relative w-100">
      <Slider {...settings} className="feat-caro">
        {/* Slide 1 */}
        <div className="feat-item v2">
          <div
            className="feat-img position-absolute"
            style={{ backgroundImage: `url(https://ik.imagekit.io/nfs93gxmp/Water%20Supply/4water.jpg?updatedAt=1760377958278)` }}
          ></div>
          
        </div>

        {/* Slide 2 */}
        <div className="feat-item v2">
          <div
            className="feat-img position-absolute"
            style={{ backgroundImage: `url(https://ik.imagekit.io/nfs93gxmp/Food%20Supply/5Food%20Supply.jpg?updatedAt=1760378090973)` }}
          ></div>
          
        </div>

        {/* Slide 3 */}
        <div className="feat-item v2">
          <div
            className="feat-img position-absolute"
            style={{ backgroundImage: `url(https://ik.imagekit.io/nfs93gxmp/Orphanage/2Orphans%20Support.jpg?updatedAt=1760377266581)` }}
          ></div>
         
        </div>
      </Slider>
    </div>
  </div>
</section>
<div className="w-100 text-center">
  <img
    src={imageSadqa}
    alt="Below Section"
    style={{
      width: "80%",
      height: "auto",
      marginTop: "25px",
      maxWidth: "100%",
    }}
    className="responsive-image"
  />
</div>
      
    </>
  );
  }
export default Navbar3;
